import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import { Grid, Typography, useTheme } from '@mui/material'

import useStyles from './index.styles'
import { ILocationFolder } from './types'

const FolderName = ({ folder, isSelected }: { folder: ILocationFolder; isSelected: boolean }) => {
  const theme = useTheme()

  return (
    <Grid container={true} component="span" sx={useStyles.nameWrapper}>
      {isSelected && <ArrowRightIcon sx={useStyles.selectedIcon} />}
      <Typography variant="body1" component="span" className="fs-exclude" sx={useStyles.folderName(theme, isSelected)}>
        {folder.name}
      </Typography>
    </Grid>
  )
}

export default FolderName
